var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoReject = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.001,
    height: 18,
    viewBox: "0 0 14.001 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_reject",
    d: "M465.628,513.758a1.9,1.9,0,0,1-1.858-1.939v-3.634h-6.8a1.9,1.9,0,0,0-1.859,1.939v14.122a1.9,1.9,0,0,0,1.857,1.939h10.284a1.9,1.9,0,0,0,1.859-1.939V513.758Zm-6.459,4.135a.986.986,0,1,1,1.395-1.4l1.543,1.543,1.544-1.543a.986.986,0,0,1,1.395,1.4l-1.544,1.543,1.546,1.544a.986.986,0,0,1-1.395,1.4l-1.544-1.543-1.543,1.543a.987.987,0,0,1-1.4-1.4l1.543-1.544Zm6.286-5.163H468.8l-4.234-4.234v3.344A.891.891,0,0,0,465.455,512.73Z",
    transform: "translate(-455.111 -508.185)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoReject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_reject.d98e2d85e43530d7415318ff38fb4d9e.svg";